module.exports = __webpack_public_path__ + "static/assets/1fd5be7cd5cbec194d3c470c9d5a4364.png";